import React from "react";
import { useGetHistotyList } from "../../hooks/useCrm";
import Typogaphy from "../Typography/Typography";
import { HistoriesStyled } from "./HistoriesStyle";
import Converter from "persian-date-converter";

export const Histories = ({ userdata }) => {
  const { data: HistoryList } = useGetHistotyList({
    IdS0alesOpportunities:
      userdata?.sales_opportunities[0]?.IdS0alesOpportunities,
  });
  const _date = new Converter();
  const history = HistoryList?.data?.history_user_crms;

  return (
    <>
      {history
        ? history?.map((item, index) => {
            const createDate = item.created_at;

            var dateWrapper = _date.convert(createDate, "fa");
            return (
              <HistoriesStyled key={index}>
                <div className="history-wrapper">
                  <div className="action-made">
                    <div className="d-flex align-items-center">
                      <img
                        src={`https://apicrmtermeh.metanext.biz/thumbnail/Profile/${item.Image}`}
                      />
                      <Typogaphy
                        style={{ marginRight: "5px" }}
                        className="w-100"
                      >
                        {item.FirstName} {item.LastName}: <br></br>
                        {item.DescriptionHistoryUserCrm}
                      </Typogaphy>
                    </div>
                  </div>
                  <div className="action-date">
                    <Typogaphy size="14px">{dateWrapper}</Typogaphy>
                  </div>
                </div>
              </HistoriesStyled>
            );
          })
        : null}
    </>
  );
};
